import { render, staticRenderFns } from "./NewReplacementModal.vue?vue&type=template&id=1bf4fc8f&"
import script from "./NewReplacementModal.vue?vue&type=script&lang=js&"
export * from "./NewReplacementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewReplacementModal.vue"
export default component.exports